// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"cf40bb63","211":"d8207993","240":"71a2897c","334":"8d15ce83","856":"9840e613","868":"ebdf6d2a","925":"4d332f5e"}[chunkId] + ".chunk.css";
};